import React from 'react';
import { type RouteObject, redirect } from 'react-router-dom';

const OrganizerPage = React.lazy(() => import('@/pages/organizer'));

export const organizerRoutes: RouteObject[] = [
  {
    path: 'organizer',
    loader: ({ params }) => redirect(`/${params.lang}/explore`),
  },
  {
    path: 'organizers',
    loader: ({ params }) => redirect(`/${params.lang}/explore`),
  },
  {
    path: 'organizers/:slug',
    element: <OrganizerPage />,
  },
  {
    path: 'organizer/:slug',
    element: <OrganizerPage />,
  },
];
